import React, { SyntheticEvent, useState } from 'react';
import { FormComponentProps } from 'antd/lib/form';
import { Form, Col, Row, Input, Button } from 'antd';
import { GetFieldDecoratorOptions } from 'antd/lib/form/Form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faToggleOff, faToggleOn } from '@fortawesome/pro-light-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { ProxyCredential } from 'src/types/ProxyServiceInfo';
import styles from './CreateNewServiceForm.module.less';

type CreateNewServiceFormProps = FormComponentProps & {
  onSave: (values: ProxyCredential) => void;
};

const faToggleOffIcon = faToggleOff as IconProp;
const faToggleOnIcon = faToggleOn as IconProp;
type FormFields = {
  [field: string]: any;
};

type FormConfig = {
  [field: string]: GetFieldDecoratorOptions;
};

const hasErrors = (fieldsError: Record<string, string[] | undefined>): boolean => {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
};

const formConfig: FormConfig = {
  proxyName: {
    rules: [{ required: true, whitespace: true, message: 'Proxy Service name is required!' }],
    validateTrigger: 'onBlur',
  },
  password: {
    rules: [{ required: true, whitespace: true, message: 'Password is required!' }],
    validateTrigger: 'onBlur',
  },
  userName: {
    rules: [{ required: true, whitespace: true, message: 'User Name is required!' }],
    validateTrigger: 'onBlur',
  },
  port: {
    rules: [{ required: true, whitespace: true, message: 'Port is required!' }],
    validateTrigger: 'onBlur',
  },
};

const hasRequiredFields = (fields: FormFields): boolean => {
  return Object.keys(fields).some(
    (field) =>
      fields[field] === undefined &&
      formConfig[field] !== undefined &&
      formConfig[field].rules !== undefined &&
      formConfig[field].rules!.some((rule) => rule.required !== undefined && rule.required)
  );
};
const CreateNewProxyServiceForm: React.FC<CreateNewServiceFormProps> = ({ form, onSave }) => {
  const { getFieldDecorator, getFieldsError, getFieldsValue, isFieldsTouched } = form;
  const disableSubmit =
    hasErrors(getFieldsError()) || (isFieldsTouched() && hasRequiredFields(getFieldsValue())) || !isFieldsTouched();

  const [statusEnabled, setStatusEnabled] = useState(false);
  //const [statusIpEnabled, setStatusIpEnabled] = useState(false);

  // const onToggle = (field: string) => {
  //   if (field === 'enabled') {
  //     setStatusEnabled(!statusEnabled);
  //   } 
  //   //else if (field === 'ipErrorEnabled') {
  //   //   setStatusIpEnabled(!statusIpEnabled);
  //   // }
  // };

  const handleSubmit = (event: SyntheticEvent): boolean => {
    event.preventDefault();
    form.validateFields((err, values: ProxyCredential) => {
      if (!err) {
        const newProxyService: ProxyCredential = {
          ...values,
          enabled: statusEnabled,
          //ipErrorEnabled: statusIpEnabled,
        };
        onSave(newProxyService);
      }
    });
    return false;
  };

  return (
    <div className={styles.createNewServiceFromWrapper}>
      <h1 className={styles.createNewServiceFromTitle}>Create New Service</h1>
      <Form layout="vertical" hideRequiredMark onSubmit={handleSubmit}>
        <Row gutter={24}>
          <Col span={24}>
            <Form.Item
              label={<h6 className={styles.proxyServiceLabel}>Proxy Service Name:</h6>}
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
            >
              {getFieldDecorator(
                'proxyName',
                formConfig.proxyName
              )(<Input type="text" placeholder="Please enter Proxy Service Name" />)}
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label={<h6 className={styles.userServiceLabel}>User Name:</h6>}
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
            >
              {getFieldDecorator(
                'userName',

                formConfig.userName
              )(<Input type="text" placeholder="Please enter User Name" />)}
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label={<h6 className={styles.userServiceLabel}>Password:</h6>}
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
            >
              {getFieldDecorator(
                'password',

                formConfig.password
              )(<Input type="text" autoComplete="off" placeholder="Please enter Password" />)}
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label={<h6 className={styles.userServiceLabel}>Port:</h6>}
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
            >
              {getFieldDecorator(
                'port',

                formConfig.port
              )(<Input type="text" placeholder="Please enter Port" />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              className="ant-col-12"
              label={<h6 className={styles.enabledLabel}>Enabled:</h6>}
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 4 }}
            >
              <p className={styles.serviceStatus}>
                <FontAwesomeIcon
                  icon={statusEnabled ? faToggleOnIcon : faToggleOffIcon}
                  className={styles.statusIcon}
                  onClick={() => setStatusEnabled(!statusEnabled)}
                  size="lg"
                />
              </p>
            </Form.Item>
          </Col>

          {/* <Col span={24}>
            <Form.Item
              className="ant-col-12"
              label={<h6 className={styles.enabledLabel}>IP Error Enabled:</h6>}
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 4 }}
            >
              <p className={styles.serviceStatus}>
                <FontAwesomeIcon
                  icon={statusIpEnabled ? faToggleOnIcon : faToggleOffIcon}
                  className={styles.statusIcon}
                  onClick={() => onToggle('ipErrorEnabled')}
                  size="lg"
                />
              </p>
            </Form.Item>
          </Col> */}
        </Row>
        <Row>
          <Col span={24} className={styles.serviceColumnButton}>
            <Button block type="primary" htmlType="submit" disabled={disableSubmit} className={styles.saveButton}>
              Create New Service
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Form.create<CreateNewServiceFormProps>({ name: 'name' })(CreateNewProxyServiceForm);
